class MoreList {
    constructor(element, options) {
        if (element.classList.contains('more-list-init')) return;

        this.list = element;
        this.items = element.children;
        this.isHide = false;
        this.options = {
            showCount: 5,
            endClass: 'more',
            ...options,
        };

        if (this.items.length > this.options.showCount) {
            this._init();
        }
    }

    _init = () => {
        if (window.innerWidth <= 767) {
            this._hide();
        }

        this.list.addEventListener('click', this._listHandler);
        window.addEventListener('resize', this._resizeHandler)

        this.list.classList.add('more-list-init');
    }

    _hide = () => {
        for (let i = this.options.showCount; i < this.items.length; i++) {
            const item = this.items[i];

            item.style.display = 'none';
        }

        this.list.insertAdjacentHTML('beforeend', `
            <${this.items[0].tagName} class="${this.options.endClass} js-more-list-btn"></${this.items[0].tagName}>
        `)

        this.isHide = true;
    }

    _show = () => {
        this.list.querySelector('.js-more-list-btn')?.remove();

        for (let i = this.options.showCount; i < this.items.length; i++) {
            const item = this.items[i];

            if (item.style.display === 'none') {
                item.style.display = ''
            }
        }

        this.isHide = false;
    }

    _listHandler = (e) => {
        const target = e.target.closest('.js-more-list-btn');

        if (!target) return;

        e.preventDefault();

        this._show();
    }

    _resizeHandler = () => {
        if (window.innerWidth <= 767 && !this.isHide) {
            this._hide();
        } else if (window.innerWidth > 767 && this.isHide) {
            this._show();
        }
    }
}
